<template>
    <ASelect
        v-model:value="valueState"
        placeholder="Pilih Status"
        allow-clear
        show-search
        not-found-content="Tidak ditemukan"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.search = null)"
        @select="() => (state.search = null)"
        v-bind="$attrs"
        :loading="state.loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="d in state.data" :key="d.id" :label="d.name">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="highlight(d.name)"></span>
            <!--eslint-enable-->
        </ASelectOption>
    </ASelect>
</template>

<script>
import { onMounted, watch,reactive } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        periode: {
            type: [Array, Number, String],
            default: null,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            loading: false,
            endpoint: '/api/filter/loyalty-point-status',
            data: '',
            search: '',
        })

        const fetchData = () => {
            state.loading = true

            apiClient.get(state.endpoint, { params: {
                    q: state.search,
                    periode: props.periode,
                }})
                .then(({ data }) => {
                    state.data = data.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
                    )

                    if (!data.find(item => item.id == props.value)) {
                        emit('update:value', null)
                    }
                })
                .finally(() => {
                    state.loading = false
                })
        }

        onMounted(() => {
            fetchData()
        })

        watch(() => props.periode, () => {
            fetchData()
        })

        const onSearch = debounce(value => {
            state.search = value
            fetchData()
        }, 300)

        const highlight = value => {
            return value.replace(new RegExp(state.search, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }
        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
        }
    },
}
</script>